// @ts-ignore
import defaultLogo from "../../images/titleLogixLogo.png";
import Form from "../../components/common/form/Form";
import React, { FormEvent, useEffect, useState } from "react";
import Button from "../../components/common/form/Button";
import InputField from "../../components/common/form/InputField";
import { showToast, validatePassword } from "../../helpers/utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useResetPasswordMutation, useValidateTokenMutation } from "../user/users/usersApi";
import { handleRTKQuery } from "../../helpers/utils/RtkQueryUtils";
import { Routes as AppRoutes } from "../../routes";
import { useGetTenantByUrlQuery } from "../sysAdmin/tenant/tenantApi";

const ResetPassword = () => {

    const search = useLocation().search;
    const navigate = useNavigate();

    const id = new URLSearchParams(search).get('id');
    const token = new URLSearchParams(search).get('token');

    const [newPassword, setNewPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [errors, setErrors] = useState<any>({});
    const [resetPasswordApi, resetPasswordApiResponse] = useResetPasswordMutation()
    const [validateTokenApi, validateToken] = useValidateTokenMutation();

    useEffect(() => {
        if (id && token !== null) {
            const resetPasswordBody = { id: id, token: token };

            const validateToken = async () => {
                try {
                    const response = await validateTokenApi(resetPasswordBody).unwrap();

                    if (response.errorCode === 200) {
                        const sessionFlag = response.tokenExpiredDTO?.sessionFlag;
                        const email = response.tokenExpiredDTO?.userEmail;

                        if (sessionFlag === false) {
                            navigate('/forgot-password-check', { state: { email } });
                        } else {
                            console.log("allowed to change password");
                        }
                    } else {
                        showToast(response.message, "error");
                    }

                } catch (err: any) {
                    showToast(err?.message || "Something went wrong.", "error");
                }
            };

            validateToken(); // Call the async function
        }
    }, [id, token, navigate, validateTokenApi]); // Add dependencies


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let obj = {
            id: id,
            token: token,
            newPassword: newPassword
        }
        await handleRTKQuery(
            async () => {
                return await resetPasswordApi(obj).unwrap();
            },
            () => {
                setNewPassword("");
                setConfirmPassword("");
                navigate(AppRoutes.Login.path);
            }
        )
    }

    return (
        <>
            <section className="flex flex-col min-h-[calc(100vh-48px)]">

                {/* Main form section */}
                <div className="flex-grow flex justify-center items-center bg-custom-image bg-center bg-no-repeat bg-cover before:absolute before:inset-0 before:bg-[rgba(0,0,0,30%)] before:content-[''] relative">
                    <div className="flex justify-center">
                        <div className="w-full max-w-xl lg:max-w-lg md:max-w-md">
                            <div className="backdrop-blur-[11px] bg-surface-1 rounded-lg p-12 relative z-10">
                                {/* Form component */}
                                <Form onSubmit={handleSubmit} fields={
                                    <>
                                        <div className="text-center mb-4">
                                            <img loading="lazy" src={defaultLogo} alt="" />
                                        </div>

                                        <div className="form-group mb-4">
                                            <InputField name="newPassword"
                                                type="password"
                                                required={true}
                                                onChange={(e: any) => {
                                                    setNewPassword(e.target.value);
                                                    setErrors(validatePassword(e.target.value, confirmPassword));
                                                }}
                                                value={newPassword}
                                               
                                                placeholder="New Password"
                                                hideLabel={true}
                                                error={Object.keys(errors).length > 0 && !errors.isValidSubmission && (
                                                    <ul className="text-error-1">
                                                        {errors.uppercaseChar &&
                                                            <li>{errors.uppercaseChar}</li>}
                                                        {errors.lowercaseChar &&
                                                            <li>{errors.lowercaseChar}</li>}
                                                        {errors.number && <li>{errors.number}</li>}
                                                        {errors.specialChar && <li>{errors.specialChar}</li>}
                                                        {errors.length && <li>{errors.length}</li>}
                                                    </ul>
                                                )}
                                            />

                                            <InputField name="confirmPassword"
                                                type="password"
                                                required={true}
                                                onChange={(e: any) => {
                                                    setConfirmPassword(e.target.value);
                                                    setErrors(validatePassword(newPassword, e.target.value));

                                                }}
                                                value={confirmPassword}
                                                
                                                placeholder="Confirm Password"
                                                hideLabel={true}
                                                error={errors.match && (
                                                    <div className="text-error-1">{errors.match}</div>
                                                )}
                                            />
                                        </div>

                                        <div className="form-group mb-4">
                                            <Button btnText={"Reset Password"}
                                                isLoading={resetPasswordApiResponse.isLoading}
                                                type={"submit"}
                                                isDisabled={!errors?.isValidSubmission}></Button>
                                        </div>

                                    </>
                                } />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        </>
    )
}
export default ResetPassword;